module.exports = __webpack_public_path__ + "img/bananas-food.fa7a54f6.svg";